import serverCall from "../../serverCall";

const getConversationType = (type) => {
  try {
    const response = serverCall.post(
      `/company/create-conversation?conversationType=${type}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const createChat = (
  selectedConversationType,
  companyId,
  companyName,
  userQuestion,
  tenantId
) => {
  try {
    const response = serverCall.post(
      `/company/chat?conversationId=${selectedConversationType}&companyId=${companyId}&category=${companyName}&question=${userQuestion}&tenantId=${tenantId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getAllChats = () => {
  try {
    const response = serverCall.get(`/company/get-conversation`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getSingleChat = (companyId, conversationId) => {
  try {
    const response = serverCall.get(
      `/company/get-chat-history?companyId=${companyId}&conversationId=${conversationId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const createOrganization = (body, config = {}) => {
  try {
    const response = serverCall.post(`/company/create-organization`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      ...config, // Spread the config here to include options like onUploadProgress
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteFile = (companyId, documentURL) => {
  try {
    const response = serverCall.delete(
      `/company/delete-document?companyId=${companyId}&documentURL=${encodeURIComponent(
        documentURL
      )}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const ChatService = {
  getConversationType,
  createChat,
  getAllChats,
  getSingleChat,
  createOrganization,
  deleteFile,
};

export default ChatService;
